import React, { useState } from 'react';
import { MessageThreadsContext } from './message-threads-context';
import PropTypes from 'prop-types';

export const MessageThreadsProvider = ({ children }) => {
  const [showThreads, setShowThreads] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [selectedJobFilter, setSelectedJobFilter] = useState([]);
  const [jobData, setJobData] = useState(null);
  const [candidateData, setCandidateData] = useState(null);
  const [showApplied, setShowApplied] = useState(false);
  const [candidateId, setCandidateId] = useState(null);
  const [recruiterId, setRecruiterId] = useState(null);
  const [threadId, setThreadId] = useState(null);
  const [contactedUsers,setContactedUsers] = useState([])

  const openThreadModal = (id = null, threadId = null) => {
    setJobId(id);
    setThreadId(threadId);
    setShowThreads(true);
  };

  const closeThreadModal = () => {
    setShowThreads(false);
    setJobId(null);
    setCandidateId(null);
    setShowApplied(false);
    setSelectedJobFilter([]);
    setRecruiterId(null);
    setCandidateData(null);
    setThreadId(null);
    setJobData(null);
  };

  return (
    <MessageThreadsContext.Provider
      value={{
        jobId,
        setJobId,
        showThreads,
        openThreadModal,
        closeThreadModal,
        candidateId,
        recruiterId,
        setCandidateId,
        setRecruiterId,
        selectedJobFilter,
        setSelectedJobFilter,
        candidateData,
        setCandidateData,
        threadId,
        setThreadId,
        showApplied,
        setShowApplied,
        jobData,
        setJobData,
        contactedUsers,
        setContactedUsers
      }}
    >
      {children}
    </MessageThreadsContext.Provider>
  );
};

MessageThreadsProvider.propTypes = {
  children: PropTypes.any,
};
